import React, {useEffect, useState} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {Button, Col, Form, Row} from 'react-bootstrap'
import axios from 'axios'
import {toast} from 'react-toastify'

const dashboardBreadCrumbs: Array<PageLink> = [
  {
    title: '',
    path: '',
    isSeparator: false,
    isActive: false,
  },
]

const SendNotificationsPage = () => {
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')

  const handleSubmit = async (e: any) => {
    e.preventDefault()

    let payLoad = {
      title: title,
      body: message,
    }

    const linkConfig = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASEURL}/notification/sendNotificationToAll/`,
      payLoad
    )

    toast.success('Notifications sent successfully', {
      position: 'bottom-right',
      theme: 'dark',
    })
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className='card p-5 mb-3'>
          <Row className='mb-5'>
            <Col xs={7} className=''>
              <div className='mb-4'>
                <Form.Group controlId={`subtitle1-${'index'}`}>
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type='text'
                    placeholder='Link Text'
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Group>
              </div>

              <div>
                <Form.Group controlId={`subtitle2-${'index'}`}>
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    type='text'
                    placeholder='Message'
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </Form.Group>
              </div>

              <div>
                <Button className='linkFormSubBtn' variant='success' type='submit'>
                  Send
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Form>
    </>
  )
}

const SendNotificationsWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={dashboardBreadCrumbs}>
        {intl.formatMessage({id: 'Send Notifications'})}
      </PageTitle>
      <SendNotificationsPage />
    </>
  )
}

export default SendNotificationsWrapper
